import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=aa4e00ca&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=aa4e00ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4e00ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa4e00ca')) {
      api.createRecord('aa4e00ca', component.options)
    } else {
      api.reload('aa4e00ca', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=aa4e00ca&scoped=true&", function () {
      api.rerender('aa4e00ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zyODrfCoMGXu/JS/comp/DocBox.vue"
export default component.exports